export enum BonusPeriodRecurrenceEnum {
  dateRange = 'dateRange',
  daily = 'daily',
  weekday = 'weekday',
}
